import produce from 'immer';

// TYPES
import { Types, pesquisarUsuarioPortal } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: pesquisarUsuarioPortal = {
	status: 0,
	data: null,
};

export default function pesquisarUsuarioPortalReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): pesquisarUsuarioPortal {
	return produce(state, draft => {
		switch (action.type) {
			case Types.PESQUISAR_USUARIO_PORTAL: {
				break;
			}

			case Types.PESQUISAR_USUARIO_PORTAL_SUCCESS: {
				draft.data = action.payload.data;
				break;
			}

			case Types.PESQUISAR_USUARIO_PORTAL_FAILURE: {
				break;
			}

			default:
		}
	});
}
